module.exports = __webpack_public_path__ + "img/mmdc-L.b35aae80.png";